<template>
  <div
    v-if="richText.content"
    v-html="parsedContent"
    :class="['richtext', richText.tag]"/>    
</template>

<script>

import gql from 'graphql-tag'
import marked from 'marked'
import hljs from 'highlight.js'

export default {
  name: 'RichText',
  data() {
    return {
      richText: {}
    }
  },
  props: [
    'id'
  ],
  apollo: {
    richText: {
      query: gql`query RichText ($id: ItemId) {
        richText(filter: {id: {eq: $id}}) {
          content
          tag
        }
      }`,
      variables() {
        return {
          id: this.id
        }
      }
    }
  },
  computed: {
    parsedContent() {
      return marked(this.richText.content, {
        sanitize: false,
        highlight: (code, lang) => hljs.highlightAuto(code, [lang]).value
      });
    }
  }
}
</script>

<style lang="less">
.richtext {
  .hljs {
    display: block;
    background: white;
    padding: 0.5em;
    color: #333333;
    overflow-x: auto;
  }

  .hljs-comment,
  pre code .hljs-meta {
    color: #969896;
  }

  .hljs-string,
  .hljs-variable,
  .hljs-template-variable,
  .hljs-strong,
  .hljs-emphasis,
  .hljs-quote {
    color: #df5000;
  }

  .hljs-keyword,
  .hljs-selector-tag,
  .hljs-type {
    color: #a71d5d;
  }

  .hljs-literal,
  .hljs-symbol,
  .hljs-bullet,
  .hljs-attribute {
    color: #0086b3;
  }

  .hljs-section,
  .hljs-name {
    color: #63a35c;
  }

  .hljs-tag {
    color: #333333;
  }

  .hljs-title,
  .hljs-attr,
  .hljs-selector-id,
  .hljs-selector-class,
  .hljs-selector-attr,
  .hljs-selector-pseudo {
    color: #795da3;
  }

  .hljs-addition {
    color: #55a532;
    background-color: #eaffea;
  }

  .hljs-deletion {
    color: #bd2c00;
    background-color: #ffecec;
  }

  .hljs-link {
    text-decoration: underline;
  }
}
</style>
